export default __webpack_public_path__ + "static/media/35A32A_2_0-025fa958221af01892d9b408f6ab0abc.bd76ee3b.woff";